import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { environment } from './environments/environment';

// AWS Config
import { Amplify } from 'aws-amplify';
import Auth from 'app/core/auth-shim';
import aws_exports from './aws-exports';

const resolvedCookieDomain = environment.cookieDomain || 
  (typeof window !== 'undefined' ? window.location.hostname : undefined) || 'localhost';

Amplify.configure({
  ...aws_exports,
  Auth: {
    ...(aws_exports as Record<string, any>).Auth,
    cookieStorage: {
      domain: resolvedCookieDomain,
      path: '/',
      expires: 365,
      sameSite: 'strict',
      secure: environment.production,
    },
  },
  API: {
    ...(aws_exports as Record<string, any>).API,
    graphql_headers: async () => {
      const session = await Auth.currentSession();
      return {
        Authorization: session.getIdToken().getJwtToken(),
        Active_Account: 'my account',
        Active_Account_Role: 'some role',
      };
    },
  },
});

if (environment.production) {
  enableProdMode();

  if (typeof window !== 'undefined' && window.console) {
    const noop = () => { /* noop in prod */ };
    window.console.log = noop;
    window.console.info = noop;
    window.console.debug = noop;
  }
}

// The Clean Bootstrap
bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));
